/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigSiteSelect_ConfigFragment = { __typename: 'ConfigurationModel', id: string, site?: { __typename: 'Site', id: string, name: string, address?: string | null } | null };

export type ConfigSiteSelect_CustomerFragment = { __typename: 'Customer', id: string, sites: Array<{ __typename: 'Site', id: string, name: string, address?: string | null }> };

export type ConfigUpdateDisplaySiteMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdateSiteInput;
}>;


export type ConfigUpdateDisplaySiteMutation = { __typename: 'Mutation', configurationUpdateSite: { __typename: 'ConfigurationModel', id: string, site?: { __typename: 'Site', id: string, name: string, address?: string | null } | null } };

export const ConfigSiteSelect_ConfigFragmentDoc = gql`
    fragment ConfigSiteSelect_config on ConfigurationModel {
  id
  site {
    id
    name
    address
  }
}
    `;
export const ConfigSiteSelect_CustomerFragmentDoc = gql`
    fragment ConfigSiteSelect_customer on Customer {
  id
  sites {
    id
    name
    address
  }
}
    `;
export const ConfigUpdateDisplaySiteDocument = gql`
    mutation ConfigUpdateDisplaySite($input: ConfigurationUpdateSiteInput!) {
  configurationUpdateSite(input: $input) {
    id
    site {
      id
      name
      address
    }
  }
}
    `;
export type ConfigUpdateDisplaySiteMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdateDisplaySiteMutation, ConfigUpdateDisplaySiteMutationVariables>;

/**
 * __useConfigUpdateDisplaySiteMutation__
 *
 * To run a mutation, you first call `useConfigUpdateDisplaySiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdateDisplaySiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdateDisplaySiteMutation, { data, loading, error }] = useConfigUpdateDisplaySiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdateDisplaySiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdateDisplaySiteMutation, ConfigUpdateDisplaySiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdateDisplaySiteMutation, ConfigUpdateDisplaySiteMutationVariables>(ConfigUpdateDisplaySiteDocument, options);
      }
export type ConfigUpdateDisplaySiteMutationHookResult = ReturnType<typeof useConfigUpdateDisplaySiteMutation>;
export type ConfigUpdateDisplaySiteMutationResult = ApolloReactCommon.MutationResult<ConfigUpdateDisplaySiteMutation>;
export type ConfigUpdateDisplaySiteMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdateDisplaySiteMutation, ConfigUpdateDisplaySiteMutationVariables>;